/* NOREGRETS buy box: slider, pack selector, sticky bar, add to cart. */
(function () {
  var root = document.getElementById('nr-buybox');
  if (!root) return;

  var slides = Array.prototype.slice.call(root.querySelectorAll('[data-nr-slide]'));
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-nr-thumb]'));
  var counter = root.querySelector('[data-nr-count]');
  var index = 0;

  function show(next) {
    if (!slides.length) return;
    index = (next + slides.length) % slides.length;
    slides.forEach(function (s, i) { s.classList.toggle('is-active', i === index); });
    thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === index); });
    if (counter) counter.textContent = (index + 1) + ' / ' + slides.length;
  }

  thumbs.forEach(function (t, i) {
    t.addEventListener('click', function () { show(i); });
  });
  var prev = root.querySelector('[data-nr-prev]');
  var next = root.querySelector('[data-nr-next]');
  if (prev) prev.addEventListener('click', function () { show(index - 1); });
  if (next) next.addEventListener('click', function () { show(index + 1); });

  var stage = root.querySelector('[data-nr-stage]');
  if (stage && slides.length > 1) {
    stage.setAttribute('tabindex', '0');
    stage.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { show(index - 1); }
      if (e.key === 'ArrowRight') { show(index + 1); }
    });
    var x0 = null;
    stage.addEventListener('touchstart', function (e) { x0 = e.changedTouches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) { show(dx < 0 ? index + 1 : index - 1); }
      x0 = null;
    }, { passive: true });
  }
  show(0);

  var packs = Array.prototype.slice.call(root.querySelectorAll('[data-nr-pack]'));
  var bar = root.querySelector('[data-nr-sticky]');
  var barPack = root.querySelector('[data-nr-sticky-pack]');
  var barPrice = root.querySelector('[data-nr-sticky-price]');

  function selected() {
    return packs.filter(function (p) { return p.classList.contains('is-selected'); })[0] || null;
  }
  function syncBar() {
    var sel = selected();
    if (!sel || !barPack) return;
    barPack.textContent = sel.getAttribute('data-pack-label');
    barPrice.textContent = sel.getAttribute('data-price-label');
  }
  packs.forEach(function (pack) {
    pack.addEventListener('click', function () {
      if (pack.getAttribute('data-available') !== 'true') return;
      packs.forEach(function (p) {
        p.classList.toggle('is-selected', p === pack);
        p.setAttribute('aria-pressed', p === pack ? 'true' : 'false');
      });
      syncBar();
    });
  });
  syncBar();

  var anchor = root.querySelector('.nr-hero__atc');
  if (bar && anchor && 'IntersectionObserver' in window) {
    bar.hidden = false;
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      bar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
    }, { threshold: 0 }).observe(anchor);
  }

  var busy = false;
  root.querySelectorAll('[data-nr-atc]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var sel = selected();
      var err = root.querySelector('[data-nr-atc-error]');
      if (!sel || busy) return;
      busy = true;
      btn.disabled = true;
      var sp = btn.querySelector('.nx-cta__sp');
      if (sp) sp.hidden = false;
      if (err) err.hidden = true;

      fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: Number(sel.getAttribute('data-variant-id')), quantity: 1 })
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (j) { throw new Error(j.description || 'Could not add to cart.'); });
          return fetch('/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: { resource: cart, sourceId: 'nr-buybox', data: { source: 'product-form-component', itemCount: cart.item_count, variantId: sel.getAttribute('data-variant-id') } }
          }));
        })
        .catch(function (e) { if (err) { err.textContent = e.message; err.hidden = false; } })
        .finally(function () { busy = false; btn.disabled = false; if (sp) sp.hidden = true; });
    });
  });
})();
